'use client';
import * as Styled from './styled';
import { ColumnWithDType } from '../../types';
import { RenderHeaderCellProps } from 'react-data-grid';
import { TRenderAsEnum } from '../../DataGrid/lib';
import Input from '@/components/Input';

const DetailsEditor: React.FC<{ name: string; value: any; onChange: (value: string | null | undefined) => void }> = ({
  name,
  value,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('event', event);
    const val = event.target.value === 'null' ? null : event.target.value;
    onChange(val);
  };

  return (
    <Input.RadioButtonGroup
      noLabel
      cols={3}
      tight
      options={[
        { label: 'true', value: 'true' },
        { label: 'false', value: 'false' },
        { label: 'null', value: 'null' },
      ]}
      value={value?.toString() || 'null'}
      name={name}
      onChange={handleChange}
    />
  );
};

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    value: boolean | null;
    rootPath?: never;
    onChange?: (value: string | null | undefined) => void;
  }
> = ({ field, value, rootPath, onChange, ...rest }) => {
  return onChange ? (
    <DetailsEditor name={field.name as string} value={value} onChange={onChange} />
  ) : (
    <Styled.Details {...rest}>
      <div className="cell-content">
        <Input.RadioButtonGroup
          noLabel
          cols={3}
          tight
          options={[
            { label: 'true', value: 'true' },
            { label: 'false', value: 'false' },
            { label: 'null', value: 'null' },
          ]}
          value={value?.toString() || 'null'}
          name={field.name as string}
        />
      </div>
    </Styled.Details>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    value: string;
    renderAs: TRenderAsEnum;
  }
> = ({ field, value, renderAs, ...rest }) => {
  return (
    <Styled.Cell {...rest}>
      <span>
        {value === null || value === undefined ? (
          <Styled.NullValue>NULL</Styled.NullValue>
        ) : (
          <Styled.Value $value={value}>{value?.toString().trim()}</Styled.Value>
        )}
      </span>
    </Styled.Cell>
  );
};

export const Header: React.FC<RenderHeaderCellProps<any> & { children: React.ReactNode }> = ({ children, ...rest }) => {
  const field = rest.column as ColumnWithDType;
  return (
    <Styled.Header>
      <div className="header-cell-name">{field.name}</div>
      {children}
    </Styled.Header>
  );
};
